<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{ date }}</div>
      <span class="title">{{ topTitle }}态势分析</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping"></use>
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping"></use>
        </svg>
      </div>
      <div class="back" @click="back">
        <img src="@/assets/meiyu/back.png" alt="" />
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div v-loading="loading" id="centermap" class="homepage-map"></div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col v-for="(item, index) in yj" :key="index" :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name"><img v-if="item.iconUrl !== undefined" :src="item.iconUrl" width="18px" height="18px" style="margin-right:10px" />{{ item.name }}</p>
          <p class="warn-num">
            <b>{{ item.num }}</b
            ><span>个</span>
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="tccontrol">
      <el-button type="primary" @click="tcdrop">
        图层控制
        <i v-if="control_con === false" class="el-icon-caret-top el-icon--right"></i>
        <i v-else class="el-icon-caret-bottom el-icon--right"></i>
      </el-button>
      <div v-show="control_con" class="control_con">
        <el-checkbox-group v-model="checkList" @change="controlcheck()">
          <el-checkbox label="雨量站"></el-checkbox>
          <el-checkbox label="水库站"></el-checkbox>
          <el-checkbox label="河道站"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!-- <div class="hyperlinks">
      <ul class="hyperlinksList">
        <li class="hyperlinksItem"
            :class="{'hyperlinksItem_active':index==selecterLink}"
            v-for="(item, index) in hyperlinksData"
            @click="selecterLinkClick(item, index)"
            :key="index"><a :href="item.link"
             target="_blank">{{item.name}}</a></li>
      </ul>
    </div> -->
    <div class="hyperlinks1">
      <ul class="hyperlinksList1">
        <li class="hyperlinksItem1" :class="{ hyperlinksItem_active1: index == selecterLink1 }" v-for="(item, index) in hyperlinksData1" @click="selecterLinkClick(item, index)" :key="index">
          <el-popover placement="bottom" title="流域简介" width="300" trigger="hover" :content="jjContent" v-model="visible">
            <a slot="reference" @click="visible = !visible" :href="item.link" target="_blank">{{ item.name }}</a>
            <!-- <a slot="reference" @click="visible = !visible">流域简介</a> -->
          </el-popover>
        </li>
      </ul>
    </div>
    <div class="left">
      <div class="realtimerain">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">实时雨情</span>
                <div class="selected_time">
                  <span class="time_item" :class="{ item_active: index == choosed }" v-for="(item, index) in selectedTime" :key="index" @click="checkItem(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="qlymyl" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div class="descword">
              全流域面雨量<span class="num">{{ qlymyl }}</span
              ><span class="danwei">mm</span>
            </div>
            <img src="@/assets/homepage_img/jianbianbg.png" alt="" />
          </div>
          <div class="barcharts" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div id="rainchart"></div>
          </div>
          <div class="area_rainfall" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <span class="name">测站雨量Top3</span>
            <div class="topthree">
              <div class="topitem" v-for="(item, index) in areaRainfallData" :key="index">
                <span class="topdesc">{{ item.name }}</span>
                <span class="val">{{ item.value }}<span class="danwei">mm</span></span>
              </div>
            </div>
          </div>
          <div class="cztable" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table :data="areaRainfallData2" :max-height="tableheight2" style="width:100%;" stripe :row-class-name="tableRowClassName1">
              <el-table-column prop="name" header-align="center" align="center" label="站点名称" min-width="80"> </el-table-column>
              <el-table-column header-align="center" align="center" prop="value" label="雨量" min-width="80"> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="sk" ref="sk">
        <div class="contain">
          <div class="title reservoirtitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">水库水位</span>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content">
            <el-table :data="reservoirWaterData" :max-height="tableheight1" style="width:100%;" stripe :row-class-name="reservoirWaterRowClass" @row-click="handleRowClick">
              <el-table-column prop="stnm" label="站点名称" min-width="90"> </el-table-column>
              <el-table-column align="right" prop="water" label="水位" min-width="70"> </el-table-column>
              <el-table-column align="right" prop="overflowWarningWater" label="超汛限" min-width="70"> </el-table-column>
              <el-table-column align="right" prop="warningWater" label="汛限水位" min-width="80"> </el-table-column>
              <!-- <el-table-column header-align="center"
                               align="right"
                               prop="topElevationOfSpillway"
                               label="溢洪道顶高程"
                               min-width="150">
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
      <div class="zz" ref="zz">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <span class="titlename_span">河道水位</span>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content">
            <el-table :data="riverWaterLevel" :max-height="tableheight2" style="width:100%;" stripe :row-class-name="tableRowClassName1" @row-click="handleRowClick">
              <el-table-column prop="stnm" label="站点名称" min-width="80"> </el-table-column>
              <el-table-column header-align="right" align="right" prop="water" label="水位" min-width="45"> </el-table-column>
              <el-table-column header-align="right" align="right" prop="overflowWarningWater" label="超警戒" min-width="45"> </el-table-column>
              <el-table-column header-align="right" align="right" prop="warningWater" label="警戒水位" min-width="60"> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 雨量柱状图、雨量水位表 -->
    <div v-show="rainfallPop" class="rainfall_pop" ref="rainfallPop">
      <div class="pop_title">{{ rainfallPopName }}</div>
      <!-- <span class="close_pop" @click="rainfallPop = false">×</span> -->
      <!-- <span class="san"></span> -->
      <el-tabs type="border-card" @tab-click="rainWaterTabsChange">
        <el-tab-pane label="水位雨量图">
          <div class="water_rain_top">
            <div class="block">
              <el-date-picker
                v-model="waterRainBeginTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="Global.pickerOptionsStart(waterRainEndTime)"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
            <span class="icon">-</span>
            <div class="block">
              <el-date-picker
                v-model="waterRainEndTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="Global.pickerOptionsEnd(waterRainBeginTime)"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
            <el-select v-model="wrIntervalTime" placeholder="请选择">
              <el-option v-for="item in intervalTime" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <el-button type="primary" @click="wrSearch('wr')">查询</el-button>
          </div>
          <div class="water_rain_down">
            <div id="waterRain"></div>
          </div>
          <span class="unit waterUnit">水位(m)</span>
          <span class="unit rainUnit">雨量(mm)</span>
        </el-tab-pane>
        <el-tab-pane label="雨量水位表">
          <div class="water_rain_top">
            <div class="block">
              <el-date-picker
                v-model="waterRainBeginTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="Global.pickerOptionsStart(waterRainEndTime)"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
            <span class="icon">-</span>
            <div class="block">
              <el-date-picker
                v-model="waterRainEndTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="Global.pickerOptionsEnd(waterRainBeginTime)"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
            <el-select v-model="rwIntervalTime" placeholder="请选择">
              <el-option v-for="item in intervalTime" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <el-button type="primary" @click="wrSearch('rw')">查询</el-button>
          </div>
          <div class="water_rain_down">
            <el-table
              :data="rainWaterData"
              border
              stripe
              v-loading="loading5"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              :max-height="tableheight4"
              highlight-current-row
              style="width: 100%"
            >
              <el-table-column label="序号" type="index" width="50"> </el-table-column>
              <el-table-column property="time" label="时间" width="120"> </el-table-column>
              <el-table-column property="rainValue" label="雨量" width="120"> </el-table-column>
              <el-table-column property="waterValue" label="水位"> </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import * as L from 'leaflet'
import screenfull from 'screenfull'
// import icon from 'leaflet/dist/images/marker-icon.png'
// import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import monitorTypes from '@/store/types/monitor'
import meiyuTypes from '@/store/types/meiyu'
import comprehensiveMapTypes from '@/store/types/comprehensiveMap'
import request from '@/utils/request'
// import homepageTypes from '@/store/types/homepage'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
var echarts = require('echarts')
export default {
  name: 'meiyu',
  components: {},
  data() {
    return {
      riverMarkers: [], // 河道站
      rainMarkers: [], // 雨量站
      reservoirMarkers: [], // 水库站
      rwIntervalTime: '60', // 实时雨情水位雨量图间隔时间
      wrIntervalTime: '60', // 实时雨情雨量水位表间隔时间
      intervalTime: [
        { value: '30', label: '30分钟' },
        { value: '60', label: '1小时' }
      ], // 间隔时间
      control_con: false,
      checkList: [],
      rainfallPop: false,
      rainfallPopName: '', // 实时雨情自定义弹窗数据
      waterRainData: [], // 实时雨情自定义弹窗水位雨量图数据
      rainWaterData: [], // 实时雨情自定义弹窗雨量水位表数据
      waterRainBeginTime: '', // 实时雨情水位雨量图开始时间
      waterRainEndTime: '', // 实时雨情水位雨量图结束时间
      rainWaterBeginTime: '', // 实时雨情雨量水位表开始时间
      rainWaterEndTime: '', // 实时雨情雨量水位表结束时间
      tableheight4: document.documentElement.clientHeight - document.documentElement.clientHeight * 0.8,
      loading5: false,
      qlymyl: '',
      routerFlag: '',
      topTitle: '',
      watchfull: '',
      isFullscreen: false,
      myChartHeight: '',
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      riverWaterLevel: [],
      reservoirWaterData: [],
      areaRainfallData: [],
      areaRainfallData2: [],
      riverBasinData: [],
      hydrologicalStationData: [],
      stationTop10LeftData: [],
      stationTop10RightData: [],
      hyperlinksData: [
        {
          name: '卫星云图',
          link: 'http://www.zjwater.gov.cn/col/col1513112/index.html',
          className: 'satellite'
        },
        {
          name: '雷达图',
          link: 'https://smart.zj121.com/radarNew/index.html', // 'http://api.dayuteam.cn/cloud/widget/getRadar',
          className: 'radar'
        },
        {
          name: '天气气象',
          link: 'http://hz.zj.weather.com.cn/hztq/index.html',
          className: 'weather'
        },
        {
          name: '1小时降水预报',
          link: 'http://smart.zj121.com/tqwpagesnew/dqyb/yxsjspt.html',
          className: 'forecast1'
        },
        {
          name: '3小时降水预报',
          link: 'http://smart.zj121.com/tqwpagesnew/dqyb/sxsjspt.html',
          className: 'forecast3'
        }
      ],
      hyperlinksData1: [
        {
          name: '流域简介',
          className: 'raindetail'
        }
      ],
      allrain: '',
      watername: '',
      wateroverflow: '',
      aDDVCD: '',
      cACD: '',
      stationName: '',
      reservoirScale: '',
      orderField: '',
      desc: '',
      documentwidth: document.documentElement.clientWidth,
      meiyurain: [],
      tops: [],
      alldz: [],
      loading: true,
      loading1: true,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      tableheight: 10,
      tableheight1: 10,
      tableheight2: 10,
      showLegend: true,
      hiddenLegend: true,
      superpolice: [],
      gates: [],
      tableData: [],
      selectedTime: [
        {
          name: '24小时',
          value: '24h'
        },
        {
          name: '6小时',
          value: '6h'
        },
        {
          name: '3小时',
          value: '3h'
        },
        {
          name: '1小时',
          value: '1h'
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        },
        {
          name: '河道',
          value: 'river'
        }
      ],
      choosed: 3,
      choosed1: 1,
      choosed2: 2,
      choosed3: 2,
      choosed4: 1,
      selecterLink: '',
      selecterLink1: '',
      gataData: [],
      type: '1h',
      chartname: [],
      topsixvalue: [],
      minwidth: '75',
      moregate: [],
      yj: [],
      sID: '1',
      sTID: '214',
      stationType: '2',
      waterFactor: '',
      maxHoldRainData: '',
      minHoldRainData: '',
      rivercoordinate: [],
      map: '',
      dialogVisible: false,
      dialogStation: false,
      therainchart: false,
      beforepoint: [],
      startTime72: '',
      endTime72: '',
      jjContent: ''
    }
  },
  methods: {
    // 图层下拉功能
    tcdrop() {
      this.control_con = !this.control_con
    },
    // 图层控制
    controlcheck() {
      let theone = this.checkList.slice(-1)
      this.checkList = theone
      if (theone[0] === '雨量站') {
        // 清除河道站点数据
        this.riverMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除水库站点数据
        this.reservoirMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        this.currentMap = false
        // this.lamap = false
        this.drawRainPoints()
      } else if (theone[0] === '水库站') {
        // 清除河道站点数据
        this.riverMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除雨量站点数据
        this.rainMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        this.currentMap = false
        // this.lamap = false
        this.reservoirwater(1)
      } else if (theone[0] === '河道站') {
        // 清除雨量站点数据
        this.rainMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除水库站点数据
        this.reservoirMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        this.currentMap = false
        // this.lamap = false
        this.riverwater(1)
      } else {
        this.lamap = true
        this.currentMap = false
        // 清除雨量站点数据
        this.rainMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除水库站点数据
        this.reservoirMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除河道站点数据
        this.riverMarkers.forEach((element) => {
          this.map.removeLayer(element)
        })
        // 清除降雨等值面
        // this.map.removeLayer(this.imageLayer)
        this.lamap = true
        this.dzmlegend = false
        this.currentMap = false
      }
      // else {
      //   this.lamap = true
      //   this.dzmlegend = false
      //   this.currentMap = false
      //   if (this.imageLayer) {
      //     this.map.removeLayer(this.imageLayer)
      //   }
      // }
    },
    selecterLinkClick(item, index) {
      this.selecterLink = index
    },
    buttonfull() {
      if (!screenfull.enabled) {
        // this.$message({
        //   message: '不支持全屏',
        //   type: 'warning'
        // })
        return false
      } else {
        screenfull.toggle()
        // this.$message({
        //   message: '全屏',
        //   type: 'success'
        // })
      }
    },
    back() {
      this.isFullscreen = true
      this.$nextTick(() => {
        this.$router.go(-1)
      })
    },
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById('rainchart'))
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          text: '各乡镇面雨量',
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '-4%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: this.chartname,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function() {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: this.topsixvalue,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row'
      } else if (rowIndex === 2) {
        return 'success-row'
      }
      return ''
    },
    tableRowClassName1({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        return 'warning-yellow-row'
      }
      return ''
    },
    reservoirWaterRowClass({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        return 'warning-red-row'
      }
      return ''
    },
    getnowtime() {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date = year + '年' + this.conver(month) + '月' + this.conver(date) + '日' + ' ' + weekend + ' ' + this.conver(hours) + ':' + this.conver(minutes) + ':' + this.conver(seconds)
    },
    conver(s) {
      return s < 10 ? '0' + s : s
    },
    leaflet(arr) {
      let map = ''
      map = L.CreateTianDiTuMap('centermap', {
        crs: L.CRS.EPSG4490,
        zoomControl: false
      }).setView([30.17, 119.4], 11)
      L.tileLayer
        .CustomArcGISServerLayer({
          minZoom: 8, // 最小缩放等级
          maxZoom: 21 // 最大缩放等级
        })
        .addTo(map)
      // GeoJson数据
      switch (this.cACD) {
        case '黄泽江流域':
          this.drawBasinJson('hzj')
          map.setView([29.5, 121.02], 11)
          break
        case '长乐江流域':
          this.drawBasinJson('clj')
          map.setView([29.5, 120.65], 11)
          break
        case '澄潭江流域':
          this.drawBasinJson('ctj')
          map.setView([29.33, 120.75], 11)
          break
        case '新昌江流域':
          this.drawBasinJson('xcj')
          map.setView([29.43, 120.95], 11)
          break
        default:
          break
      }
      this.map = map
    },
    drawBasinJson(name) {
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      request.get('http://' + window.location.host + '/yjjson/basinJson/' + name + '.json').then((res) => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(this.map)
        this.drawBoundary(res.data.features[0].geometry.coordinates, this.map)
      })
    },
    drawBoundary(blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach((item) => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, { color: 'transparent', fillColor: '#242422', fillOpacity: 0.8 }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    // 实时雨情点击切换
    checkItem(item, index) {
      this.loading1 = true
      this.chartname = []
      this.topsixvalue = []
      this.choosed = index
      this.choosed2 = index
      this.choosed3 = index
      this.type = item.value
      this.staterain()
    },
    // 水库水情
    // reservoirwater () {
    //   this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
    //     aDDVCD: this.aDDVCD,
    //     cACD: this.cACD,
    //     stationName: this.stationName,
    //     reservoirScale: this.reservoirScale,
    //     orderField: this.orderField,
    //     desc: this.desc
    //   }).then(data => {
    //     this.reservoirWaterData = data.rows
    //     this.loading = false
    //     this.dataSort('overflowWarningWater', this.reservoirWaterData)
    //   })
    // },
    // 水库水情
    reservoirwater(val, num) {
      let _this = this
      if (val) {
        this.reservoirScale = ''
      }
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
          sID: this.sID,
          aDDVCD: this.aDDVCD,
          cACD: this.cACD,
          stationName: this.stationName,
          reservoirScale: this.reservoirScale,
          orderField: this.orderField,
          desc: this.desc
        })
        .then((data) => {
          if (!val) {
            this.reservoirWaterData = data.rows
            this.loading = false
            this.dataSort('overflowWarningWater', this.reservoirWaterData)
          }
          if (num !== 1) {
            // 地图打点
            let reservior = L.icon({
              iconUrl: require('@/assets/homepage_img/reservior-icon.png'),
              shadowUrl: require('@/assets/homepage_img/reservior-icon.png'),
              iconSize: [15, 15],
              shadowSize: [15, 15]
            })
            let coordinates = data.rows
            coordinates.forEach((item) => {
              // if (item.overflowWarningWater < 0) {
              let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
              this.reservoirMarkers.push(markers)
              markers.bindTooltip('<b>' + item.stnm + '</b>', {
                parmanent: true,
                sticky: true,
                className: 'anim-tooltip'
              })
              var thestid
              if (item.reservoirName) {
                thestid = item.stid
              } else {
                thestid = item.stid
                // debugger
                // alert(thestid)
              }
              // 点的点击事件
              markers.on('click', function() {
                // _this.map.closePopup()
                _this.num += 1
                _this.$store
                  .dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
                    sID: _this.sID,
                    sTID: thestid,
                    beginTime: _this.startTime72,
                    endTime: _this.endTime72,
                    span: '60'
                  })
                  .then((data) => {
                    let maxWaterTime = data.maxWaterTime.substring(0, 8)
                    let minWaterTime = data.minWaterTime.substring(0, 8)
                    let themaxwater = data.maxWater === undefined ? '--' : data.maxWater
                    let theminwater = data.minWater === undefined ? '--' : data.minWater
                    markers.bindPopup(
                      '<div class="villaegName echart_name">' +
                        item.stnm +
                        '▪ 72小时水位过程线' +
                        '</div>' +
                        '<div class="villaegName echart_title">水位(m)</div>' +
                        '<div id="tab">' +
                        '<ul class="tab">' +
                        '<li class="tab_nav on">' +
                        '<div class="waterEcharts" id="myecharts' +
                        _this.num +
                        '"></div>' +
                        '<div class="waterLine">' +
                        '<div class="water_item" ">' +
                        '<span>最高水位：' +
                        themaxwater +
                        ' m' +
                        '</span>' +
                        '<span>时间：' +
                        maxWaterTime +
                        ' 时' +
                        '</span>' +
                        '</div>' +
                        '<div class="water_item" ">' +
                        '<span>最低水位：' +
                        theminwater +
                        ' m' +
                        '</span>' +
                        '<span>时间：' +
                        minWaterTime +
                        ' 时' +
                        '</span>' +
                        '</div>' +
                        '</div>' +
                        '</li>' +
                        '</ul>' +
                        '</div>'
                    )
                    // this.waterfallArrPoint.push(markers)
                    this.openPopup()
                    _this.$nextTick(() => {
                      _this.waterChart('myecharts' + _this.num, data)
                    })
                  })
              })
              // }
            })
          }
          this.loading = false
          this.skloading = false
        })
    },
    // 河道水情
    riverwater(showpointer) {
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
          aDDVCD: this.aDDVCD,
          cACD: this.cACD,
          stationName: this.stationName,
          orderField: this.orderField,
          desc: this.desc
        })
        .then((data) => {
          this.riverWaterLevel = data.rows
          this.loading = false
          this.dataSort('overflowWarningWater', this.riverWaterLevel)
          // 河道站打点
          if (showpointer) {
            this.drawRiverPoints(data)
          }
        })
    },
    // 河道站打点
    drawRiverPoints(data) {
      let _this = this
      data.rows.forEach((item) => {
        // if (item.overflowWarningWater) {
        let reservior = L.icon({
          iconUrl: require('@/assets/comprehensive/water.gif'),
          shadowUrl: require('@/assets/comprehensive/water.gif'),
          iconSize: [25, 25],
          shadowSize: [25, 25]
        })
        let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
        // 将新的maeker数据赋值给clearArrPoint，以便重新查询到点后清空原有点
        this.riverMarkers.push(markers)
        markers.bindTooltip('<b>' + item.stnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        var thestid
        if (item.reservoirName) {
          thestid = item.stid
        } else {
          thestid = item.id
        }
        // 点的点击事件
        markers.on('click', function() {
          // _this.map.closePopup()
          _this.num += 1
          _this.$store
            .dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
              sID: _this.sID,
              sTID: thestid,
              beginTime: _this.startTime72,
              endTime: _this.endTime72,
              span: '60'
            })
            .then((data) => {
              let maxWaterTime = data.maxWaterTime.substring(0, 8)
              let minWaterTime = data.minWaterTime.substring(0, 8)
              let themaxwater = data.maxWater === undefined ? '--' : data.maxWater
              let theminwater = data.minWater === undefined ? '--' : data.minWater
              markers.bindPopup(
                '<div class="villaegName echart_name">' +
                  item.stnm +
                  '▪ 72小时水位过程线' +
                  '</div>' +
                  '<div class="villaegName echart_title">水位(m)</div>' +
                  '<div id="tab">' +
                  '<ul class="tab">' +
                  '<li class="tab_nav on">' +
                  '<div class="waterEcharts" id="myecharts' +
                  _this.num +
                  '"></div>' +
                  '<div class="waterLine">' +
                  '<div class="water_item" ">' +
                  '<span>最高水位：' +
                  themaxwater +
                  ' m' +
                  '</span>' +
                  '<span>时间：' +
                  maxWaterTime +
                  ' 时' +
                  '</span>' +
                  '</div>' +
                  '<div class="water_item" ">' +
                  '<span>最低水位：' +
                  theminwater +
                  ' m' +
                  '</span>' +
                  '<span>时间：' +
                  minWaterTime +
                  ' 时' +
                  '</span>' +
                  '</div>' +
                  '</div>' +
                  '</li>' +
                  '</ul>' +
                  '</div>'
              )
              // this.waterfallArrPoint.push(markers)
              this.openPopup()
              _this.$nextTick(() => {
                _this.waterChart('myecharts' + _this.num, data)
              })
            })
        })
        // }
      })
    },
    // 雨量站打点
    drawRainPoints() {
      let _this = this
      this.loading = true
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RAIN, {
          sID: this.sID,
          aDDVCD: this.aDDVCD,
          cACD: this.cACD,
          appType: '1',
          beginTime: '',
          endTime: '',
          showFreq: true
        })
        .then((data) => {
          data.rows.forEach((item, index) => {
            if (item.stnm === '跃进备用站') {
            }
            // let reservior = L.icon({
            //   iconUrl: require('@/assets/comprehensive/rainicon.png'),
            //   shadowUrl: require('@/assets/comprehensive/rainicon.png'),
            //   iconSize: [18, 18],
            //   shadowSize: [18, 18]
            // })
            var myIcon1 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_0.png'),
              iconAnchor: [8, 8]
            })
            var myIcon2 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_1.png'),
              iconAnchor: [8, 8]
            })
            var myIcon3 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_2.png'),
              iconAnchor: [8, 8]
            })
            var myIcon4 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_3.png'),
              iconAnchor: [8, 8]
            })
            var myIcon5 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_4.png'),
              iconAnchor: [8, 8]
            })
            var myIcon6 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_5.png'),
              iconAnchor: [8, 8]
            })
            var myIcon7 = L.icon({
              iconUrl: require('@/assets/comprehensive/yl_6.png'),
              iconAnchor: [8, 8]
            })
            var myIcon = myIcon1
            if (item.rain === 0) {
              myIcon = myIcon1
            } else if (item.rain > 0 && item.rain < 10) {
              myIcon = myIcon2
            } else if (item.rain >= 10 && item.rain < 25) {
              myIcon = myIcon3
            } else if (item.rain >= 25 && item.rain < 50) {
              myIcon = myIcon4
            } else if (item.rain >= 50 && item.rain < 100) {
              myIcon = myIcon5
            } else if (item.rain >= 100 && item.rain < 250) {
              myIcon = myIcon6
            } else if (item.rain >= 250) {
              myIcon = myIcon7
            }
            let marker = L.marker([item.lttd, item.lgtd], { icon: myIcon }).addTo(this.map)
            // 将新的maeker数据赋值给clearArrPoint，以便重新查询到点后清空原有点
            this.rainMarkers.push(marker)
            // marker.bindTooltip('<b>' + item.stnm + '</b>', {
            //   parmanent: true,
            //   sticky: true,
            //   className: 'anim-tooltip'
            // })
            marker.bindPopup('<div class="rainfall_popup_content" id="rainfall_popup_content' + index + '"></div>').bindTooltip('<div class="villaegName">' + item.stnm + '</div>')
            marker.on('click', function(e) {
              let rainfallPopup = _this.$refs['rainfallPop']
              let rainfallPopupCcontent = document.getElementById('rainfall_popup_content' + index)
              _this.tempSTID = item.id
              _this.rainfallPop = true
              _this.setDefaultTime2()
              _this.getRainfallData(_this.wrIntervalTime, '0')
              _this.getRainfallData(_this.wrIntervalTime, '1')
              rainfallPopupCcontent.append(rainfallPopup)
              _this.loading5 = false
            })
          })
          this.loading = false
        })
    },
    // 水位雨量图/雨量水位表 切换
    rainWaterTabsChange(val) {
      if (val.index === '0') {
        this.getRainfallData('60', '0')
      } else {
        this.getRainfallData('60', '1')
      }
    },
    // 弹窗内查询
    wrSearch(type) {
      if (type === 'wr') {
        this.getRainfallData(this.wrIntervalTime, '0')
      } else {
        this.getRainfallData(this.rwIntervalTime, '1')
      }
    },
    // 实时雨情对应stid站点水位雨量/雨量水位数据
    getRainfallData(intervalTime, num) {
      let _this = this
      this.$store
        .dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
          sID: _this.sID,
          sTID: _this.tempSTID,
          stationType: '',
          beginTime: _this.waterRainBeginTime,
          endTime: _this.waterRainEndTime,
          span: intervalTime
        })
        .then((data) => {
          _this.rainfallPopName = data.stnm
          if (num === '0') {
            // 水位雨量图
            _this.rainChart(data)
          } else if (num === '1') {
            // 雨量水位表
            let finalData = []
            for (let i = 0; i < data.tMs.length; i++) {
              finalData[i] = {}
              if (data.tMs && data.tMs[i]) {
                finalData[i].time = data.tMs[i]
              }
              if (data.rainValues && data.rainValues[i]) {
                finalData[i].rainValue = data.rainValues[i]
              }
              if (data.waterValues && data.waterValues[i]) {
                finalData[i].waterValue = data.waterValues[i]
              }
            }
            _this.rainWaterData = finalData
          }
        })
        .catch(() => {})
    },
    // 实时雨情markers折线图
    rainChart(data) {
      let myChart = this.$echarts.init(document.getElementById('waterRain'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['雨量', '水位', '警戒水位']
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.tMs
        },
        yAxis: [
          {
            type: 'value',
            min: data.startWaterMark,
            scale: true,
            interval: 100,
            axisLabel: {
              formatter: function(value, index) {
                return value.toFixed(2) + 'm'
              }
            }
          },
          {
            type: 'value',
            interval: 30,
            inverse: true,
            axisLabel: {
              formatter: '{value} mm'
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: data.rainValues
          },
          {
            name: '水位',
            type: 'line',
            itemStyle: {
              color: '#48D1CC'
            },
            data: data.waterValues
          },
          {
            name: '警戒/汛限水位',
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              color: 'red'
            },
            data: data.wrZs
          }
        ]
      })
    },
    rainoverflow() {
      this.$store.dispatch(meiyuTypes.GET_WATER_OVERFLOW, { sID: '1', cADCD: this.aDDVCD, cACD: this.cACD }).then((data) => {
        this.yj.push({ name: '雨量1h超警', num: data.total1, iconUrl: require('@/assets/meiyu/ylcj.png') })
        this.yj.push({ name: '雨量3h超警', num: data.total3, iconUrl: require('@/assets/meiyu/ylcj.png') })
        if (data.total1 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf1h
          coordinates.forEach((item) => {
            L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
          })
        }
        if (data.total3 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf3h
          coordinates.forEach((item) => {
            L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
          })
        }
      })
    },
    resoverflow(type) {
      this.$store.dispatch(meiyuTypes.GET_RES_OVERFLOW, { stationType: type, sID: '1', cACD: this.cACD }).then((data) => {
        if (type === 1) {
          this.yj.push({ name: '河道水位超警', num: data.riverWarningTotal, iconUrl: require('@/assets/meiyu/swcj.png') })
          if (data.riverWarningTotal > 0) {
            var river = L.icon({
              iconUrl: require('@/assets/meiyu/swcj.png'),
              shadowUrl: require('@/assets/meiyu/swcj.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rows

            coordinates.forEach((item) => {
              var marker = L.marker([item.lttd, item.lgtd], { icon: river }).addTo(this.map)
              marker.bindTooltip('<span>' + item.stnm + ':' + item.water + 'm 超警:<span style="color:red;">' + item.diff + '</span>m</span>', {
                parmanent: true,
                sticky: true,
                className: 'anim-tooltip'
              })
              // debugger
              // marker.addTo(this.map)
              marker.on('click', function() {})
            })
          }
        } else {
          this.yj.push({ name: '水库超汛限', num: data.reservoirTotal, iconUrl: require('@/assets/meiyu/skcxx.png') })
          if (data.reservoirTotal > 0) {
            var reservior = L.icon({
              iconUrl: require('@/assets/meiyu/skcxx.png'),
              shadowUrl: require('@/assets/meiyu/skcxx.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rowsOfReservoir
            coordinates.forEach((item) => {
              L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
            })
          }
        }
      })
    },
    warnvillage() {
      this.$store.dispatch(meiyuTypes.GET_WARN_VILLAGE, { aDCD: '', cANM: this.cACD, pageIndex: '1', pageSize: '100' }).then((data) => {
        this.yj.push({ name: '预警村落', num: data.total, iconUrl: require('@/assets/meiyu/yjcl.png') })
        if (data.total > 0) {
          var reservior = L.icon({
            iconUrl: require('@/assets/meiyu/yjcl.png'),
            shadowUrl: require('@/assets/meiyu/yjcl.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.results
          coordinates.forEach((item) => {
            L.marker([item.lat, item.lng], { icon: reservior }).addTo(this.map)
          })
        }
      })
    },
    // 数据排序
    dataSort(type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    staterain() {
      this.$store
        .dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
          addvcd: this.aDDVCD,
          type: this.type,
          stationCount: this.stationCount,
          townCount: this.townCount,
          partCount: this.partCount,
          cACD: this.cACD
        })
        .then((data) => {
          this.qlymyl = data.avgRain
          let townData = data.townRain
          this.areaRainfallData = data.stationRain.slice(0, 3)
          this.areaRainfallData2 = data.stationRain
          let chartname = []
          let topsixvalue = []
          townData.forEach((item) => {
            chartname.push(item.name)
            topsixvalue.push(item.value)
          })
          this.chartname = chartname
          this.topsixvalue = topsixvalue
          this.drawChart()
          this.loading1 = false
        })
        .catch((err) => console.log(err))
    },
    // 河道水情行选中定位坐标
    handleRowClick(item) {
      this.beforepoint.forEach((item) => {
        this.map.removeLayer(item)
      })
      var _this = this
      this.num++
      // this.map.setView([item.lttd, item.lgtd], 18)
      this.map.flyTo([item.lttd, item.lgtd], 11, {
        animate: true,
        duration: 1
      })
      let reservior = L.icon({
        iconUrl: require('@/assets/defenseposture/gl.gif'),
        // iconUrl: require('@/assets/comprehensive/water.gif'),
        // shadowUrl: require('@/assets/comprehensive/water.gif'),
        iconSize: [15, 15],
        shadowSize: [15, 15]
      })
      // let coordinates = data.rows
      // coordinates.forEach(item => {
      let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
      markers.bindTooltip('<b>' + item.stnm + '</b>', {
        parmanent: true,
        sticky: true,
        className: 'anim-tooltip'
      })
      this.beforepoint.push(markers)
      var thestid
      if (item.reservoirName) {
        thestid = item.stid
      } else {
        thestid = item.id
      }
      this.$store
        .dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
          sID: this.sID,
          sTID: thestid,
          beginTime: this.startTime72,
          endTime: this.endTime72,
          span: '60'
        })
        .then((data) => {
          let maxWaterTime = data.maxWaterTime.substring(0, 8)
          let minWaterTime = data.minWaterTime.substring(0, 8)
          let themaxwater = data.maxWater === undefined ? '--' : data.maxWater
          let theminwater = data.minWater === undefined ? '--' : data.minWater
          markers
            .bindPopup(
              '<div class="villaegName echart_name">' +
                item.stnm +
                '▪ 72小时水位过程线' +
                '</div>' +
                '<div class="villaegName echart_title">水位(m)</div>' +
                '<div id="tab">' +
                '<ul class="tab">' +
                '<li class="tab_nav on">' +
                '<div class="waterEcharts" id="myecharts' +
                this.num +
                '"></div>' +
                '<div class="waterLine">' +
                '<div class="water_item" ">' +
                '<span>最高水位：' +
                themaxwater +
                ' m' +
                '</span>' +
                '<span>时间：' +
                maxWaterTime +
                ' 时' +
                '</span>' +
                '</div>' +
                '<div class="water_item" ">' +
                '<span>最低水位：' +
                theminwater +
                ' m' +
                '</span>' +
                '<span>时间：' +
                minWaterTime +
                ' 时' +
                '</span>' +
                '</div>' +
                '</div>' +
                '</li>' +
                '</ul>' +
                '</div>'
            )
            .bindTooltip('<div class="villaegName">' + item.stnm + '</div>')
          // this.waterfallArrPoint.push(markers)
          markers.on('click', function() {
            let echartId = 'myecharts' + _this.num
            _this.getRainWaterMinutesTotal(echartId, thestid)
          })
        })
    },
    getRainWaterMinutesTotal(echartId, sTID) {
      this.$store
        .dispatch(comprehensiveMapTypes.GET_RAINWATER_MINUTES_TOTAL, {
          sID: this.sID,
          sTID: sTID,
          beginTime: this.startTime72,
          endTime: this.endTime72,
          span: '60'
        })
        .then((data) => {
          this.waterChart(echartId, data)
        })
        .catch(() => {})
    },
    // 实时水情markers72小时水位折线图
    waterChart(echartId, data) {
      let myChart = this.$echarts.init(document.getElementById(echartId))
      // myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '5%',
          right: '5%',
          top: '3%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.tMs,
          splitLine: {
            show: true
          }
        },
        yAxis: {
          type: 'value',
          splitNumber: 6,
          min: data.minWater - 0.5,
          minInterval: 2,
          maxInterval: 100,
          nameTextStule: {
            fontWeight: 'bold'
          },
          // splitLine: {
          //   show: true
          // },
          axisLabel: {
            formatter: function(value, index) {
              return value.toFixed(2) + 'm'
            }
          }
        },
        series: [
          {
            name: '水位',
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              color: '#00BBCC'
            },
            lineStyle: {
              // type: 'dashed',
              color: '#00BBCC'
            },
            data: data.waterValues
          },
          {
            name: '汛限/警戒水位',
            symbolSize: 0,
            type: 'line',
            itemStyle: {
              color: '#EE4000'
            },
            data: data.wrZs
          }
        ]
      })
    },
    // 计算当前时刻往前72小时
    computed72Time() {
      var date = new Date()
      var warnTMMAXMs = date.getTime()
      var maxDate = new Date(warnTMMAXMs)
      var maxYY = maxDate.getFullYear()
      var maxMM = maxDate.getMonth() + 1
      var maxDD = maxDate.getDate()
      var maxHH = maxDate.getHours()
      var maxMin = maxDate.getMinutes()
      var warnTMMinMs = date.getTime() - 60 * 60 * 1000 * 72
      var minDate = new Date(warnTMMinMs)
      var minYY = minDate.getFullYear()
      var minMM = minDate.getMonth() + 1
      var minDD = minDate.getDate()
      var minHH = minDate.getHours()
      var minMin = minDate.getMinutes()
      // 现在时刻
      this.startTime72 =
        minYY + '-' + (minMM < 10 ? '0' + minMM : minMM) + '-' + (minDD < 10 ? '0' + minDD : minDD) + ' ' + (minHH < 10 ? '0' + minHH : minHH) + ':' + (minMin < 10 ? '0' + minMin : minMin)
      this.endTime72 =
        maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
    },
    // 设置默认起止时间
    setDefaultTime2() {
      var date = new Date()
      var warnTMMAXMs = date.getTime()
      var maxDate = new Date(warnTMMAXMs)
      var maxYY = maxDate.getFullYear()
      var maxMM = maxDate.getMonth() + 1
      var maxDD = maxDate.getDate()
      var maxHH = maxDate.getHours()
      var maxMin = maxDate.getMinutes()
      // 现在时刻
      this.selecttime1 = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + '08:00'
      this.selecttime2 =
        maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
      this.selecttime3 = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + '08:00'
      this.selecttime4 =
        maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
      // 雨量信息时间显示
      var startTime = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + '08:00'
      var endTime = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
      this.currentTime = '(' + startTime + '到' + endTime + ')'
      this.waterRainBeginTime = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + '00:00'
      this.waterRainEndTime =
        maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
      this.rainWaterBeginTime = maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + '00:00'
      this.rainWaterEndTime =
        maxYY + '-' + (maxMM < 10 ? '0' + maxMM : maxMM) + '-' + (maxDD < 10 ? '0' + maxDD : maxDD) + ' ' + (maxHH < 10 ? '0' + maxHH : maxHH) + ':' + (maxMin < 10 ? '0' + maxMin : maxMin)
    }
  },
  computed: {
    getTopTitle() {
      return this.$store.state.topTitleName
    }
  },
  created() {
    this.computed72Time()
  },
  mounted() {
    // 获取路由跳转标记，标记当前跳转的是哪个页面
    this.routerFlag = this.getTopTitle
    switch (this.routerFlag) {
      case 'szsbasin':
        this.cACD = ''
        this.topTitle = '嵊州市'
        // this.addressjson = 'nantiaoxi.json'
        break
      case 'hzjbasin':
        this.cACD = '黄泽江流域'
        this.topTitle = '黄泽江流域'
        this.jjContent = '黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域黄泽江流域'
        break
      case 'cljbasin':
        this.cACD = '长乐江流域'
        this.topTitle = '长乐江流域'
        this.jjContent = '长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域长乐江流域'
        break
      case 'ctjbasin':
        this.cACD = '澄潭江流域'
        this.topTitle = '澄潭江流域'
        this.jjContent = '澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域澄潭江流域'
        break
      case 'xcjbasin':
        this.cACD = '新昌江流域'
        this.topTitle = '新昌江流域'
        this.jjContent = '新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域新昌江流域'
        break
      default:
        break
    }
    // console.log(this.routerFlag, this.topTitle)
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
    }
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.rainoverflow()
    this.resoverflow(1)
    this.resoverflow(2)
    this.warnvillage()
    this.$nextTick(() => {
      this.leaflet()
    })
    this.getnowtime()
    this.riverwater()
    this.reservoirwater('', 1)
    this.loading = false
    this.$nextTick(() => {
      let rainContentDiv = document.getElementsByClassName('raintitle')
      let rainDiv = document.getElementsByClassName('realtimerain')
      this.tableheight = rainDiv[0].offsetHeight - rainContentDiv[0].offsetHeight - 30
      let reservoirDiv = document.getElementsByClassName('sk')
      this.tableheight1 = reservoirDiv[0].offsetHeight - rainContentDiv[0].offsetHeight - 25
      let riverDiv = document.getElementsByClassName('zz')
      this.tableheight2 = riverDiv[0].offsetHeight - rainContentDiv[0].offsetHeight - 25
    })
    this.staterain()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 9999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>
<style lang="less" scoped>
@import url('~@/assets/map/leaflet.css');
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 1080px;
  position: relative;
}
@media screen and (min-height: 1100px) {
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  /* min-height: 36px; */
  height: 87px;
  /* height: 100%; */
}
#chartall,
#danzhan,
#zhazhan {
  z-index: 9999999 !important;
}
#rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 850px;
  height: 85px;
  left: 50%;
  margin-left: -425px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
.row-legend {
  width: 185px;
  height: 230px;
  position: absolute;
  bottom: 0;
  top: 745px;
  left: 1237px;
  z-index: 9999;
}
.legend {
  height: 230px;
  background: none;
  background-image: url(~@/assets/homepage_img/legendbody.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.legend-closed {
  width: 10px;
  height: 10px;
  padding: 0;
  line-height: 12px;
  position: absolute;
  color: #fff;
  top: 13px;
  right: 22px;
  cursor: pointer;
}
.show-legend {
  width: 150px;
  height: 35px;
  position: absolute;
  top: 721px;
  right: 525px;
  line-height: 40px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  z-index: 9999;
  color: #fff;
  font-size: 16px;
  text-align: center;
  background-image: url(~@/assets/homepage_img/legendtitle.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.el-icon-arrow-up {
  transform: rotateZ(0deg);
  margin-left: 110px;
}
.el-icon-arrow-up-rotatez {
  transform: rotateZ(180deg);
  animation: slowClose 0.2s ease;
}
@keyframes slowClose {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(180deg);
  }
}
</style>
<style lang="less" scoped>
.meiyu {
  // background: #21251f;
  height: 100%;
  position: relative;
  .el-dialog {
    .topthree {
      width: 100%;
      height: 70px;
      .topitem {
        position: relative;
        color: #fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 20%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 80%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url('~@/assets/meiyu/top.png');
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full {
      .back;
      right: 75px;
    }
  }
  .left {
    width: 430px;
    height: 850px;
    position: absolute;
    // background: #fec307;
    top: 75px;
    bottom: 40px;
    left: 0px;
    z-index: 9999;
    .warning {
      width: 430px;
      height: 85px;
      line-height: 85px;
      text-align: center;
      background-image: url('~@/assets/meiyu/warningbox.png');
      background-repeat: no-repeat;
      background-size: 110% 200%;
      background-position: -14px -43px;
      img {
        margin-left: 30px;
        width: 147px;
        height: 23px;
      }
      span {
        margin-left: 20px;
        font-size: 18px;
        color: #fff;
        // margin-top: -5px;
        float: right;
        margin-right: 55px;
      }
    }
    .realtimerain {
      opacity: 0.93;
      width: 100%;
      height: 960px;
      margin-top: 10px;
      background: #060a22;
      // box-shadow: 0 0 5px #283955 inset;
      box-shadow: 0 0 12px #253578;
      padding: 15px 27px;
      .contain {
        width: 380px;
        height: 100%;
        // background: #fec307;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 20%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 80%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .qlymyl {
          margin-top: 20px;
          position: relative;
          .descword {
            color: #fff;
            position: absolute;
            font-size: 18px;
            line-height: 22px;
            left: 50%;
            margin-left: -90px;
            margin-top: 15px;
            .num {
              color: #fec307;
              font-size: 28px;
              font-style: italic;
            }
            .danwei {
              font-size: 14px;
              font-style: italic;
            }
          }
          img {
            width: 384px;
            height: 55px;
          }
        }
        .barcharts {
          height: 216px;
          position: relative;
          margin-top: 20px;
          #rainchart {
            width: 380px;
            height: 216px;
          }
        }
        .area_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            .topitem {
              width: 30%;
              position: relative;
              background: url('~@/assets/meiyu/bluebox.png');
              // background: url("~@/assets/homepage_img/gpqmyl_bg.png");
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                left: 25px;
                width: 90px;
                left: 50%;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                top: 35px;
                left: 45px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url('~@/assets/meiyu/longbox.png');
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .riverBasin_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            background: url('~@/assets/homepage_img/glymyl_bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
            .topitem {
              width: 25%;
              position: relative;
              img {
                width: 117px;
                height: 71px;
              }
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                left: 25px;
                width: 90px;
                left: 50%;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                color: #00deff;
                top: 35px;
                left: 45px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url('~@/assets/meiyu/longbox.png');
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .hydrologicalStation_rainfall {
          height: 130px;
          position: relative;
          color: #fff;
          .topthree {
            height: 70px;
            margin-top: 10px;
            justify-content: space-between;
            display: flex;
            .topitem {
              width: 49%;
              position: relative;
              background-repeat: no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              &:nth-of-type(1) {
                background: url('~@/assets/homepage_img/swzmyl_left_bg.png');
              }
              &:nth-of-type(2) {
                background: url('~@/assets/homepage_img/swzmyl_right_bg.png');
              }
              .topdesc {
                font-size: 14px;
                position: absolute;
                top: 11px;
                right: 25px;
                width: 90px;
                margin-left: -45px;
                height: 15px;
                text-align: center;
              }
              .val {
                .topdesc;
                top: 35px;
                right: 40px;
                font-size: 24px;
                text-align: center;
                font-style: italic;
                font-weight: 500;
                .danwei {
                  font-size: 14px;
                  position: absolute;
                  top: 10px;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url('~@/assets/meiyu/longbox.png');
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
        .stationTop10_rainfall {
          height: 320px;
          position: relative;
          color: #fff;
          .topthree {
            height: 220px;
            margin-top: 25px;
            background: url('~@/assets/homepage_img/czTop10.png');
            background-repeat: no-repeat;
            background-position: center center;
            .topthree_left {
              .topitem {
                &:nth-of-type(1) .tag_num {
                  background: url('~@/assets/homepage_img/top10_1.png');
                }
                &:nth-of-type(2) .tag_num {
                  background: url('~@/assets/homepage_img/top10_2.png');
                }
                &:nth-of-type(3) .tag_num {
                  background: url('~@/assets/homepage_img/top10_3.png');
                }
                &:nth-of-type(4) .tag_num {
                  background: url('~@/assets/homepage_img/top10_4.png');
                }
                &:nth-of-type(5) .tag_num {
                  background: url('~@/assets/homepage_img/top10_5.png');
                }
              }
            }
            .topthree_right {
              padding-left: 5%;
              .topitem {
                &:nth-of-type(1) .tag_num {
                  background: url('~@/assets/homepage_img/top10_6.png');
                }
                &:nth-of-type(2) .tag_num {
                  background: url('~@/assets/homepage_img/top10_7.png');
                }
                &:nth-of-type(3) .tag_num {
                  background: url('~@/assets/homepage_img/top10_8.png');
                }
                &:nth-of-type(4) .tag_num {
                  background: url('~@/assets/homepage_img/top10_9.png');
                }
                &:nth-of-type(5) .tag_num {
                  background: url('~@/assets/homepage_img/top10_10.png');
                }
              }
            }
            .topthree_item {
              width: 50%;
              float: left;
              .topitem {
                width: 100%;
                height: 45px;
                line-height: 45px;
                float: left;
                position: relative;
                background-repeat: no-repeat;
                background-position: center center;
                span {
                  display: block;
                  float: left;
                }
                .tag_num {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  margin-top: 12px;
                  background-repeat: no-repeat;
                  background-position: center center;
                }
                .topdesc {
                  font-size: 14px;
                  width: 90px;
                  height: 100%;
                  text-align: left;
                }
                .val {
                  .topdesc;
                  width: 50px;
                  text-align: right;
                }
              }
            }
          }
          .detail {
            margin-top: 40px;
            height: 70px;
            width: 390px;
            background-image: url('~@/assets/meiyu/longbox.png');
            background-repeat: no-repeat;
            background-size: 98% 100%;
            display: inline-block;
            .itemdesc {
              margin-top: 10px;
              width: 130px;
              height: 70px;
              text-align: center;
              font-size: 14px;
              display: inline-block;
              .tit {
                display: block;
              }
              .val {
                font-size: 24px;
                color: #00deff;
                font-style: italic;
                font-weight: 500;
                display: inline-block;
                margin-top: 10px;
                img {
                  width: 14px;
                  height: 24px;
                }
                .danwei {
                  margin-left: -5px;
                }
              }
            }
          }
          .name {
            font-size: 13px;
            color: #fff;
            position: relative;
            font-weight: bold;
          }
        }
      }
    }
    .realtimewater {
      .realtimerain;
      margin-top: 10px;
      height: 520px;
      padding: 15px 0;
      .contain {
        height: 290px;
        width: 405px;
        .title {
          margin-left: 27px;
        }
        .content {
          margin-top: 10px;
          width: 430px;
        }
      }
    }
  }
  .right {
    width: 430px;
    height: 800px;
    position: absolute;
    top: 75px;
    bottom: 40px;
    right: 0px;
    z-index: 9999;
    .sk {
      .left>.realtimerain;
      height: 420px;
      .echart_content {
        width: 380px;
        height: 280px;
        margin-top: 10px;
        padding-top: 30px;
        position: relative;
        overflow: hidden;
      }
      .echart_down {
        width: 380px;
        height: 70px;
        margin-top: 15px;
        padding: 10px;
        border-top: 1px solid #2dd9f8;
        .echart_down_img {
          width: 180px;
          height: 100%;
          float: left;
          background-image: url('~@/assets/meiyu/right_echart_down.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .echart_down_right {
          width: 180px;
          height: 100%;
          float: left;
          .down_right_title {
            width: 100%;
            height: 50%;
            font-size: 15px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            display: block;
          }
          .down_right_num {
            width: 100%;
            height: 50%;
            font-size: 26px;
            line-height: 30px;
            text-align: center;
            color: #2dd9f8;
            display: block;
            b {
              font-style: italic;
            }
          }
        }
      }
    }
    .zz {
      .left>.realtimerain;
      height: 520px;
      .more {
        float: right;
        font-size: 15px;
        color: #00deff;
        cursor: pointer;
      }
      .content {
        .tag_item {
          display: block;
          float: left;
        }
        .tag_num {
          width: 75%;
        }
        .tag {
          width: 15%;
          height: 23px;
          margin-left: 4px;
          background-repeat: no-repeat;
          background-position: center center;
        }
        .tag_up {
          background-image: url('~@/assets/homepage_img/tag_up.png');
        }
        .tag_down {
          background-image: url('~@/assets/homepage_img/tag_down.png');
        }
        .tag_smooth {
          background-image: url('~@/assets/homepage_img/tag_smooth.png');
        }
        .gateitem {
          margin-top: 17px;
          width: 380px;
          // height: 100px;
          border: 1px solid #1a3a6c;
          .gatetop {
            height: 35px;
            line-height: 35px;
            background: #0f3164;
            .name {
              font-size: 15px;
              color: #fff;
              float: left;
              margin-left: 17px;
            }
            .time {
              color: #fff;
              font-size: 14px;
              float: right;
              margin-right: 10px;
            }
            .desc {
              font-size: 14px;
              color: #00deff;
              float: right;
              margin-right: 17px;
            }
          }
          .gateicons {
            margin-top: 6px;
            .gateicon {
              margin-left: 17px;
              height: 55px;
              position: relative;
              margin-top: 5px;
              // margin-bottom: 5px;
              text-align: center;
              width: 22px;
              height: 38px;
              img {
                width: 22px;
                height: 38px;
              }
              span {
                color: #fff;
                font-size: 14px;
                display: block;
              }
            }
          }
        }
      }
    }
  }
  .tccontrol {
    position: absolute;
    top: 180px;
    left: 460px;
    z-index: 500;
    .control_con {
      width: 150px;
      height: auto;
      background: #fff;
      border-radius: 5px;
      margin-top: 5px;
      padding: 10px 15px;
      padding-top: 0;
      .el-checkbox {
        margin-top: 10px;
      }
    }
  }
  .hyperlinks {
    width: 950px;
    height: 60px;
    position: absolute;
    top: 1000px;
    left: 480px;
    z-index: 9999;
    .hyperlinksList {
      width: 765px;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      line-height: 50px;
      .hyperlinksItem {
        &:hover {
          background: #0590cf;
        }
        &:nth-of-type(4),
        &:nth-of-type(5) {
          width: 155px;
        }
        list-style-type: none;
        width: 110px;
        height: 45px;
        padding: 5px 0;
        margin: 0 10px;
        border: 1px solid #0878b4;
        box-shadow: 0 0 5px #0878b4;
        line-height: 35px;
        border-radius: 30px;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
        font-weight: 600;
        float: left;
        a {
          color: #ffffff;
        }
      }
      .hyperlinksItem_active {
        background: #0590cf;
      }
    }
  }
  .hyperlinks1 {
    width: 150px;
    height: 60px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    margin-left: -55px;
    z-index: 400;
    .hyperlinksList1 {
      width: 165px;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      line-height: 50px;
      .hyperlinksItem1 {
        &:hover {
          background: #0590cf;
        }
        list-style-type: none;
        width: 110px;
        height: 45px;
        padding: 5px 0;
        margin: 0 10px;
        border: 1px solid #0878b4;
        line-height: 35px;
        border-radius: 30px;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
        // font-weight: 600;
        float: left;
        a {
          color: #ffffff;
          font-size: 18px;
        }
      }
      .hyperlinksItem_active1 {
        background: #0590cf;
      }
      .centerboth {
        width: 155px;
      }
    }
  }
}
.meiyu /deep/ .el-dialog {
  z-index: 9999999;
  background-color: #060a22;
  margin-top: 22vh !important;
  width: 47%;
  // height: 50%
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    // height: 100px;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        // margin-bottom: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.meiyu /deep/ .el-table tr {
  // text-align: center;
  color: #fff;
  background: #060a22;
}
.meiyu /deep/ .el-table .el-table__body-wrapper tr:hover {
  cursor: pointer;
}
.meiyu /deep/ .el-table tr.el-table__row--striped td {
  background: #061737;
}
.meiyu /deep/ .el-table td {
  // text-align: center;
  padding: 5px 0;
  border: none;
}
.meiyu /deep/ .el-table th.is-leaf {
  border: none;
}
.meiyu /deep/ .el-table th {
  // text-align: center;
  color: #00deff;
  background: #060a22;
}
.meiyu /deep/ .el-table .warning-red-row {
  background: #850b1a !important;
}
.meiyu /deep/ .el-table .warning-yellow-row {
  background: #856915 !important;
}
.meiyu /deep/ #centermap .leaflet-control-container {
  .leaflet-bottom.leaflet-right {
    display: none;
  }
}
// .meiyu /deep/ .el-table .success-row {
//   background: #850b17;
// }
.meiyu /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.meiyu /deep/ .el-table::before {
  background: #060a22;
}
.meiyu /deep/ *::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
  background-color: #072351;
}
.meiyu /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.meiyu /deep/ *::-webkit-scrollbar-thumb {
  /*width: 0.1rem;
     */
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.meiyu /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.meiyu /deep/ .el-table__body-wrapper,
.meiyu /deep/ .is-scrolling-none,
// .meiyu /deep/ .is-scrolling-right {
//   height: 80% !important;
// }
// .meiyu /deep/ .el-table__body-wrapper,
// .meiyu /deep/ .is-scrolling-none,
// .meiyu /deep/ .el-table__body{
//   height: 222px!important;
// }
.el-table {
  background: #060a22;
}
// 地图内标记点的点击事件弹窗样式
.meiyu /deep/ #centermap .leaflet-popup-pane .leaflet-zoom-animated {
  width: 600px;
  height: auto;
  .leaflet-popup-content {
    width: 555px !important;
    position: relative;
    .rainfall_popup_content {
      width: 100%;
      height: 360px;
      .rainfall_pop {
        width: 100%;
        height: 100%;
        background: #ffffff;
        padding: 5px;
        border-radius: 5px;
        .pop_title {
          width: 100%;
          height: 35px;
          padding: 5px 20px;
          font-size: 18px;
        }
        .close_pop {
          position: absolute;
          display: block;
          width: 20px;
          height: 20px;
          line-height: 20px;
          top: 5px;
          right: 5px;
          color: #6f6363;
          font-size: 26px;
          cursor: pointer;
        }
        .san {
          width: 0;
          height: 0;
          position: absolute;
          bottom: -30px;
          left: 300px;
          border: 15px solid;
          border-color: #f3f3f3 transparent transparent transparent;
        }
        .el-tabs .el-tabs__content {
          .water_rain_top {
            width: 100%;
            height: 45px;
            .block {
              width: 150px;
              height: 45px;
              float: left;
              /deep/ .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 100% !important;
              }
              /deep/ .el-input--suffix .el-input__inner {
                padding-right: 0 !important;
              }
            }
            .icon {
              width: 15px;
              height: 45px;
              color: #6f6363;
              font-size: 18px;
              line-height: 45px;
              text-align: center;
              display: block;
              float: left;
            }
            .el-select {
              width: 100px;
              height: 45px;
              margin: 0 5px;
            }
          }
          .water_rain_down {
            width: 100%;
            height: 200px;
            #waterRain {
              width: 100%;
              height: 200px;
            }
          }
        }
        .unit {
          display: block;
          width: 100px;
          height: 20px;
          position: absolute;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
          line-height: 20px;
        }
        .waterUnit {
          transform: rotateZ(-90deg);
          top: 160px;
          left: -25px;
        }
        .rainUnit {
          transform: rotateZ(90deg);
          top: 160px;
          right: -20px;
        }
      }
    }
    .villaeg_popup_content {
      width: 100%;
      height: 320px;
      .village_pop {
        width: 100%;
        height: 100%;
        background: #ffffff;
        padding: 5px;
        border-radius: 5px;
        .pop_title {
          width: 100%;
          height: 35px;
          padding: 5px 20px;
          font-size: 18px;
        }
        .close_pop {
          position: absolute;
          display: block;
          width: 20px;
          height: 20px;
          line-height: 20px;
          top: 5px;
          right: 5px;
          color: #6f6363;
          font-size: 26px;
          cursor: pointer;
        }
        .san {
          width: 0;
          height: 0;
          position: absolute;
          bottom: -30px;
          left: 300px;
          border: 15px solid;
          border-color: #f3f3f3 transparent transparent transparent;
        }
        .el-tabs .el-tabs__content {
          .water_rain_top {
            width: 100%;
            height: 45px;
            .block {
              width: 150px;
              height: 45px;
              float: left;
              /deep/ .el-date-editor.el-input,
              .el-date-editor.el-input__inner {
                width: 100% !important;
              }
              /deep/ .el-input--suffix .el-input__inner {
                padding-right: 0 !important;
              }
            }
            .icon {
              width: 15px;
              height: 45px;
              color: #6f6363;
              font-size: 18px;
              line-height: 45px;
              text-align: center;
              display: block;
              float: left;
            }
            .el-select {
              width: 100px;
              height: 45px;
              margin: 0 5px;
            }
          }
          .water_rain_down {
            width: 100%;
            height: 200px;
            .dangerInfo {
              width: 50%;
              height: 35px;
              float: left;
              border-bottom: 1px solid #ccc;
              padding-right: 30px;
              .item {
                height: 100%;
                line-height: 35px;
                float: left;
                font-size: 14px;
              }
              .item_title {
                width: 65%;
                text-align: left;
              }
              .item_value {
                width: 35%;
                text-align: right;
                color: red;
              }
              .item_black {
                color: #000000;
              }
            }
            .item_content {
              z-index: 999;
              .item_legend {
                width: 50%;
                height: 50px;
                float: left;
                line-height: 50px;
                padding: 2px 10px;
                font-size: 14px;
                border-bottom: 1px solid #ccc;
                .legend_name {
                  display: block;
                  float: left;
                  width: 50%;
                  height: 100%;
                  font-size: 14px;
                }
                .el-switch {
                  width: 50%;
                  font-size: 14px;
                  .el-switch__core {
                    width: 30px !important;
                  }
                }
              }
              .bzcs {
                background: url('~@/assets/comprehensive/bzcs.png');
              }
              .dzzh {
                background: url('~@/assets/comprehensive/dzzh.png');
              }
              .wxgb {
                background: url('~@/assets/comprehensive/wxgb.png');
              }
              .zgsw {
                background: url('~@/assets/comprehensive/zgsw.png');
              }
              .wzck {
                background: url('~@/assets/comprehensive/wzck.png');
              }
              .sz {
                background: url('~@/assets/comprehensive/sz.png');
              }
              .tyb {
                background: url('~@/assets/comprehensive/tyb.png');
              }
            }
          }
        }
      }
    }
    .villaegName {
      font-size: 18px;
      color: #303133;
    }
    .echart_title {
      position: absolute;
      font-weight: 600;
      font-size: 14px;
      transform: rotateZ(-90deg);
      top: 45%;
      left: -10px;
    }
    .echart_name {
      text-align: center;
    }
    .waterEcharts {
      width: 100%;
      height: 200px;
    }
    .waterLine {
      width: 300px;
      height: 60px;
      margin-left: 35px;
      .water_item {
        width: 100%;
        height: 30px;
        float: left;
        padding: 5px 0;
        span {
          width: 50%;
          height: 100%;
          float: left;
          display: block;
          text-align: left;
        }
      }
    }
    #tab {
      position: relative;
      width: 100%;
      height: 300px;
      margin: 0 auto;
      .list {
        width: 100%;
        height: 25px;
        padding: 0;
        margin: 2px auto;
        border-bottom: 1px solid #ccc;
      }
      li {
        list-style: none;
      }
      .list_nav {
        float: left;
        width: 90px;
        height: 25px;
        font-size: 15px;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
      }
      .active {
        color: #409eff;
        border-bottom: 1px solid #409eff;
      }
      .tab_nav {
        display: none;
        position: absolute;
        top: 25px;
        width: 100%;
      }
      .on {
        display: block;
      }
      .tab {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0 auto;
        .tabcontnet {
          width: 50%;
          height: 35px;
          margin-top: 10px;
          float: left;
          font-size: 15px;
          border-bottom: 1px solid #ccc;
          .contentname {
            margin-right: 5px;
            width: 60%;
            float: left;
          }
          .contentnum {
            width: 35%;
            float: left;
          }
        }
      }
    }
  }
}
</style>
